module.exports = "/_next/static/images/NassauLogo-190223a7d6937e735dfa60ca6ec361f4.png";